import { Box, Typography } from "@mui/material";
import SalesTicket from "./SalesTicket";
import { useParams } from "react-router-dom";

const SalesTicketPage = () => {
  const { id } = useParams();
  return (
    <Box>
      <Typography variant="h4" textAlign="center">
        Sales Ticket #{id}
      </Typography>
      <SalesTicket />
    </Box>
  );
};

export default SalesTicketPage;
